import { chatRequest } from './request';

// 找或建与档口的 C2C 房间（买家入口）
export function imRoomOpen(sellerId: number) {
  return chatRequest<API.ImRoomItem>({
    url: '/api/im/room/open',
    method: 'post',
    data: { seller_id: sellerId },
  });
}

// 我的 C2C 会话列表（买家本人房间）
export function imRoomList() {
  return chatRequest<API.ImRoomItem[]>({
    url: '/api/im/room/list',
    method: 'post',
  });
}

// 关闭房间（任一方可关，重发消息自动重开）
export function imRoomClose(roomId: number) {
  return chatRequest<API.ImRoomItem>({
    url: '/api/im/room/close',
    method: 'post',
    data: { room_id: roomId },
  });
}

// 发送消息（msgType: 1=文本 2=图片）
export function imMessageSend(roomId: number, content: string, msgType: 1 | 2) {
  return chatRequest<API.ImMessageItem>({
    url: '/api/im/message/send',
    method: 'post',
    data: { room_id: roomId, content, msg_type: msgType },
  });
}

// 房间消息（游标分页）
export function imMessageList(roomId: number, prevMsgId?: number, limit = 20) {
  return chatRequest<API.ImMessageListResult>({
    url: '/api/im/message/list',
    method: 'post',
    data: { room_id: roomId, prev_msg_id: prevMsgId, limit },
  });
}

// 标记已读（买家侧看了即清）
export function imMessageRead(roomId: number) {
  return chatRequest<void>({
    url: '/api/im/message/read',
    method: 'post',
    data: { room_id: roomId },
  });
}

// 档口是否已入驻云管家（档口页"联系客服"入口显隐数据源）
// 云管家 /adminapi/open/** 为免登录只读通道，只回显布尔；查询失败兜底 false
export function imSellerServiceAvailable(sellerId: number | string) {
  const base = (import.meta.env as any).VITE_SELLERSTORE_API || 'http://127.0.0.1:9022';
  return new Promise<boolean>((resolve) => {
    uni.request({
      url: `${base}/adminapi/open/seller/service-available`,
      method: 'GET',
      data: { dsy_seller_id: String(sellerId) },
      timeout: 8000,
      success: (res) => {
        resolve((res.data as any)?.data === true);
      },
      fail: () => {
        resolve(false);
      },
    });
  });
}
